// Ответ бэкенда «выберите значение разреза» (422 dimension_selection_required).
//
// Срез по умолчанию сервер не подставляет: у показателя с разрезами запрос
// данных должен задать значения всех разрезов. Виджет, сохранённый без них,
// показывает, какие разрезы выбрать, а не пустое место или «ошибку».

import { ApiError } from '../http';
import type { DimensionSelectionRequiredDetail } from '../types';
import { escapeHtml } from './dom';

export function dimensionSelectionRequired(error: unknown): DimensionSelectionRequiredDetail | null {
  if (!(error instanceof ApiError) || error.status !== 422) return null;
  const detail = error.detail;
  if (typeof detail !== 'object' || detail === null) return null;
  const candidate = detail as Partial<DimensionSelectionRequiredDetail>;
  if (candidate.code !== 'dimension_selection_required' || !Array.isArray(candidate.dimensions)) return null;
  return candidate as DimensionSelectionRequiredDetail;
}

export function dimensionSelectionMarkup(detail: DimensionSelectionRequiredDetail, canEdit: boolean): string {
  const names = detail.dimensions.map((dimension) => `«${dimension.name}»`).join(', ');
  const examples = detail.dimensions
    .map((dimension) => {
      const sample = dimension.values.slice(0, 3).map((item) => item.label).join('; ');
      const more = dimension.value_count > 3 ? ` и ещё ${dimension.value_count - 3}` : '';
      return `<li><b>${escapeHtml(dimension.name)}</b>: ${escapeHtml(sample)}${escapeHtml(more)}</li>`;
    })
    .join('');
  return `
    <div class="visual-notice" role="status">
      <strong>Выберите значение разреза: ${escapeHtml(names)}</strong>
      <span>Показатель разбит по этим разрезам, итог автоматически не подставляется.</span>
      <ul>${examples}</ul>
      ${canEdit ? '<button type="button" class="text-button" data-action="edit">Выбрать разрез</button>' : ''}
    </div>`;
}
